import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import NotificationImage from "../Notifications/NotificationImage";
import NotificationVideo from "../Notifications/NotificationVideo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function IntrusiveNotificationModal({
  isOpen,
  notifications,
  onClose,
  onDismiss,
  onGoToNotificationCenter,
}) {
  if (!notifications || notifications.length === 0) {
    return null;
  }

  const isSingle = notifications.length === 1;
  const hasVideo = notifications.some(
    (n) => n.notice.video && n.notice.video !== "null",
  );

  const SingleContent = ({ notification }) => (
    <div className="intrusive-notification-single">
      <div className="intrusive-notification-single__content">
        <span dangerouslySetInnerHTML={{ __html: notification.notice.text }} />
      </div>
      {notification.notice.image && (
        <div className="intrusive-notification-single__media mt-3">
          <NotificationImage noticeId={notification.notice.id} />
        </div>
      )}
      {notification.notice.video && notification.notice.video !== "null" && (
        <div className="intrusive-notification-single__media mt-3">
          <NotificationVideo videoUrl={notification.notice.video} />
        </div>
      )}
    </div>
  );

  const MultipleList = () => {
    const sorted = [...notifications].sort(
      (a, b) => new Date(b.notice.created) - new Date(a.notice.created),
    );

    return (
      <div className="intrusive-notification-list">
        {sorted.map((noti, index) => {
          const plainText = noti.notice.text.replace(/<[^>]*>/g, "");
          const previewText =
            plainText.length > 150
              ? plainText.substring(0, 150) + "..."
              : plainText;

          return (
            <div
              key={noti.notice.id}
              className={
                "intrusive-notification-list__item" +
                (index < sorted.length - 1
                  ? " intrusive-notification-list__item--bordered"
                  : "")
              }
            >
              <div className="intrusive-notification-list__item-header">
                <FontAwesomeIcon
                  icon="circle"
                  size="xs"
                  className="intrusive-notification-list__item-dot"
                />
                <h6 className="intrusive-notification-list__item-title">
                  {noti.notice.title}
                </h6>
              </div>
              <p className="intrusive-notification-list__item-preview">
                {previewText}
              </p>
              <Button
                color="link"
                size="sm"
                className="intrusive-notification-list__item-link p-0"
                onClick={onGoToNotificationCenter}
              >
                <FormattedMessage id="ReadMore" /> &rarr;
              </Button>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onDismiss}
      className={`intrusive-notification-modal${hasVideo ? "--video" : ""}`}
      centered
    >
      <ModalHeader
        toggle={onDismiss}
        className="intrusive-notification-modal__header"
      >
        <div className="intrusive-notification-modal__header-content">
          <FontAwesomeIcon
            icon="bullhorn"
            className="intrusive-notification-modal__header-icon"
          />
          <span>
            {isSingle ? (
              notifications[0].notice.title
            ) : (
              <FormattedMessage id="ImportantAnnouncements" />
            )}
          </span>
          {!isSingle && (
            <Badge className="intrusive-notification-modal__header-badge">
              {notifications.length}
            </Badge>
          )}
        </div>
      </ModalHeader>
      <ModalBody className="intrusive-notification-modal__body">
        {isSingle ? (
          <SingleContent notification={notifications[0]} />
        ) : (
          <MultipleList />
        )}
      </ModalBody>
      <ModalFooter className="intrusive-notification-modal__footer">
        <Button color="primary" outline onClick={onClose}>
          <FormattedMessage
            id={isSingle ? "MarkAsReadAndClose" : "MarkAllAsReadAndClose"}
          />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
